import { IconChevronDown } from '@hulu-react-style-components/icons';
import React from 'react';

import LinksDropDown from '../Header/LinksDropDown/LinksDropDown';
import { DropDownItem } from '../types';
import { GroupLinkWrapper, TextWrapper } from './styled';

type Props = {
  text: string;
  mainLink: string;
  subLinks: Array<DropDownItem>;
};

const GroupLinks = ({ text, mainLink, subLinks }: Props): JSX.Element => (
  <GroupLinkWrapper>
    <TextWrapper href={mainLink} target="_blank" rel="noopener noreferrer">
      {text}
      <IconChevronDown width={16} height={16} />
    </TextWrapper>
    <LinksDropDown list={subLinks} data-text={text} />
  </GroupLinkWrapper>
);

export default GroupLinks;
